// removed by extract-text-webpack-plugin
module.exports = {"summary":"PhysicianPage__summary___xMinq","headerContainer":"PhysicianPage__headerContainer___1ZJM2"};


//////////////////
// WEBPACK FOOTER
// ./study_reviewer/src/pages/PhysicianPage.css
// module id = 1219
// module chunks = 0